import { RetiredKpiTileParamsV1Schema } from "./kpiTile.js";
/**
 * Hoshin's Yjs-native KPI card (PB-234).
 *
 * It USED to reuse `KpiTileParamsSchema` because the two shapes were the same
 * one. They are not any more: the SOLVE tile became a read-only view of a KPI
 * Manager KPI, and this card is a headline number a workshop types onto a
 * Hoshin canvas — a different product object that happens to look alike.
 *
 * Binding it to the retired tile shape is therefore not a stop-gap, it is the
 * point: the card's stored content, its Y.Doc merge behaviour and its rendering
 * are all unchanged, and this file is where that claim is now made explicitly
 * instead of riding on a shared import. Whether Hoshin should ALSO bind to KPI
 * Manager is its own product decision, deliberately not taken here.
 */
export const KpiCardParamsSchema = RetiredKpiTileParamsV1Schema;
export const defaultKpiCardParams = {
    label: "New KPI",
    value: "",
    unit: "",
    higherIsBetter: false,
    recentValues: [],
};
//# sourceMappingURL=kpiCard.js.map